'use client';

import React from 'react';
import FetchUtils from '../../Utils/FetchUtils';

export function buildHubHandoffUrl(hubUrl: string, token: string) {
	const url = new URL(hubUrl);
	const fragment = new URLSearchParams({ handoff: token });
	if (url.pathname !== '/login' && url.pathname !== '/') {
		fragment.set('redirect', url.pathname + url.search);
	}
	return `${url.origin}/login#${fragment.toString()}`;
}

type Props = React.AnchorHTMLAttributes<HTMLAnchorElement> & { hubUrl: string };

export default function HubHandoffLink({ hubUrl, onClick, ...props }: Props) {
	return (
		<a
			{...props}
			href={hubUrl}
			onClick={async (event) => {
				onClick?.(event);
				if (event.defaultPrevented) return;
				if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
				event.preventDefault();
				const newWindow = props.target === '_blank' ? window.open('', '_blank') : null;
				if (newWindow) newWindow.opener = null;
				const destination = newWindow ?? window;
				try {
					const { token } = await FetchUtils.postJson<{ token: string }>('/api/auth/handoff-token', {})
						.response;
					destination.location.href = buildHubHandoffUrl(hubUrl, token);
				} catch {
					destination.location.href = hubUrl;
				}
			}}
		/>
	);
}
